import { ExternalLink } from 'lucide-react';

import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

// Dialog previews render the document at a fraction of its size — this pops
// the same URL into its own browser window for full-size reading.
export function OpenPdfInNewWindow({ url }: Readonly<{ url: string }>) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'self-start')}
      data-testid="open-pdf-new-window"
    >
      <ExternalLink aria-hidden /> Open in new window
    </a>
  );
}
